import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [currentLang, setCurrentLang] = useState<string>(i18n.language || 'en');
  
  useEffect(() => {
    setCurrentLang(i18n.language || 'en');
  }, [i18n.language]);
  
  const changeLanguage = (language: string) => {
    // Change the language first
    i18n.changeLanguage(language);
    
    // Update URL with new language parameter
    const currentSearch = new URLSearchParams(location.search);
    currentSearch.set('lang', language);
    
    // Force scroll to top immediately before navigation
    window.scrollTo(0, 0);
    
    // Then navigate to update URL without replacing history
    navigate({
      pathname: location.pathname,
      search: currentSearch.toString()
    }, { replace: true }); // Use replace to avoid adding to history
  };

  // Simple toggle button with clear indication of current state
  return (
    <div>
      {currentLang === 'en' || currentLang === 'en-US' || !currentLang ? (
        <button
          className="px-2 py-1 rounded font-semibold text-white hover:bg-primary-500/40"
          onClick={() => changeLanguage('fr')}
          aria-label="Switch to French"
        >
          FR
        </button>
      ) : (
        <button
          className="px-2 py-1 rounded font-semibold text-white hover:bg-primary-500/40"
          onClick={() => changeLanguage('en')}
          aria-label="Switch to English"
        >
          EN
        </button>
      )}
    </div>
  );
};

export default LanguageSwitcher; 